(() => {
  const root = document.body.dataset.root || '/';
  const endpoint = path => root.replace(/\/$/, '') + '/' + path;
  const status = document.querySelector('#GlobalStatus');
  const parse = html => new DOMParser().parseFromString(html, 'text/html');
  const announce = message => { if (status) status.textContent = message; };
  const words = () => ({error:document.body.dataset.error || 'Nie udało się wykonać tej czynności. Spróbuj ponownie.',added:document.body.dataset.added || 'Zestaw dodany do koszyka.',loading:document.body.dataset.loading || 'Chwileczkę…'});
  const drawer = () => document.querySelector('#CartDrawer');
  let cartBusy = false;
  let restoreFocus;
  const updateCount = count => document.querySelectorAll('[data-cart-count]').forEach(node => node.textContent = count);
  const reducedMotion=matchMedia('(prefers-reduced-motion: reduce)');
  const initShipping=(scope,previous=0)=>{
    scope.querySelectorAll('[data-shipping-progress]').forEach(bar=>{
      const fill=bar.querySelector('[data-shipping-fill]');
      const target=Number(bar.dataset.progress);
      if(!fill || !Number.isFinite(target))return;
      fill.style.transition='none';fill.style.width=(reducedMotion.matches?target:previous)+'%';
      requestAnimationFrame(()=>requestAnimationFrame(()=>{if(!fill.isConnected)return;fill.style.transition='';fill.style.width=target+'%';}));
    });
  };
  const replaceCart = html => {
    const content = parse(html || '').querySelector('#CartContents');
    if (!content) throw new Error(words().error);
    const old = document.querySelector('#CartContents');
    const previousFill=old?.querySelector('[data-shipping-fill]');
    const previousTrack=previousFill?.parentElement.getBoundingClientRect().width;
    const previous=previousTrack ? previousFill.getBoundingClientRect().width*100/previousTrack : 0;
    if (old) old.replaceWith(content);
    initShipping(content,previous);
    updateCount(content.dataset.count);
  };
  const showCart = trigger => {
    const dialog = drawer();
    if (!dialog || !dialog.showModal) { location.assign(document.body.dataset.cartUrl); return; }
    restoreFocus = trigger;
    if (!dialog.open) {dialog.showModal();initShipping(dialog,0);}
  };
  const closeCart = () => { const dialog = drawer(); if (dialog?.open) dialog.close(); };
  const refreshCart = async () => {
    const url = new URL(location.href);
    url.searchParams.set('sections', 'cart-drawer');
    const response = await fetch(url, {headers:{Accept:'application/json'}});
    if (!response.ok) throw new Error(words().error);
    const sections = await response.json();
    replaceCart(sections['cart-drawer']);
  };
  const cartError = message => { const error = document.querySelector('[data-cart-error]'); if (error) error.textContent = message; };
  const mutateCart = async (key, quantity, focusId) => {
    if (cartBusy) return;
    cartBusy = true;
    drawer()?.setAttribute('aria-busy','true');
    cartError('');
    try {
      const response = await fetch(endpoint('cart/change.js'), {method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({id:key,quantity,sections:['cart-drawer'],sections_url:location.pathname})});
      const data = await response.json();
      if (!response.ok) throw new Error(data.description || data.message || words().error);
      if (data.sections?.['cart-drawer']) replaceCart(data.sections['cart-drawer']); else await refreshCart();
      const quantityInput = focusId && document.getElementById(focusId);
      if (quantityInput) quantityInput.focus(); else drawer()?.querySelector('[data-close-cart]')?.focus();
    } catch(error) { cartError(error.message || words().error); }
    finally { cartBusy = false; drawer()?.removeAttribute('aria-busy'); }
  };
  document.addEventListener('click', async event => {
    const open = event.target.closest('[data-open-cart]');
    if (open) {
      event.preventDefault(); showCart(open); cartError('');
      try { await refreshCart(); } catch(error) { cartError(error.message || words().error); }
      return;
    }
    if (event.target.closest('[data-close-cart]')) { closeCart(); return; }
    const remove = event.target.closest('[data-remove-key]');
    if (remove) { event.preventDefault(); await mutateCart(remove.dataset.removeKey,0); return; }
    const control = event.target.closest('[data-quantity]');
    if (control) {
      const input = control.closest('.quantity-control').querySelector('input');
      if (Number(control.dataset.quantity) > 0) input.stepUp(); else input.stepDown();
      input.dispatchEvent(new Event('change',{bubbles:true}));
    }
  });
  document.addEventListener('change', event => {
    const input = event.target.closest('[data-cart-key]');
    if (input) {
      if (!input.checkValidity() || input.value === '') { input.reportValidity(); return; }
      mutateCart(input.dataset.cartKey,Number(input.value),input.id);
    }
  });
  const dialog = drawer();
  dialog?.addEventListener('close', () => { if (restoreFocus?.isConnected) restoreFocus.focus(); });
  dialog?.addEventListener('click', event => { if (event.target !== dialog) return; const box = dialog.getBoundingClientRect(); if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) closeCart(); });
  document.addEventListener('keydown', event => { if (event.key === 'Escape') document.querySelectorAll('.mobile-nav[open]').forEach(node=>node.removeAttribute('open')); });
  const pendingVideos=new WeakSet();
  const prepareVideo=video=>{video.muted=true;video.defaultMuted=true;video.playsInline=true;video.setAttribute('muted','');video.setAttribute('playsinline','');video.setAttribute('webkit-playsinline','');};
  const visibleEnough=element=>{
    const box=element.getBoundingClientRect();
    const height=window.innerHeight || document.documentElement.clientHeight;
    const width=window.innerWidth || document.documentElement.clientWidth;
    return box.width>0 && box.height>0 && Math.min(box.bottom,height)-Math.max(box.top,0)>=Math.min(100,box.height*.15) && box.right>0 && box.left<width;
  };
  const startVideo=video=>{
    if(!video.paused || pendingVideos.has(video))return;
    prepareVideo(video);video.autoplay=true;video.setAttribute('autoplay','');
    video.preload='metadata';pendingVideos.add(video);
    const result=video.play();
    if(result?.then)result.then(()=>{pendingVideos.delete(video);delete video.dataset.autoplayBlocked;}).catch(()=>{pendingVideos.delete(video);video.dataset.autoplayBlocked='true';});
    else pendingVideos.delete(video);
  };
  const stopVideo=video=>{video.autoplay=false;video.removeAttribute('autoplay');if(!video.paused)video.pause();};
  const initPortraitVideo=frame=>{
    if(frame.dataset.autoplayReady)return;frame.dataset.autoplayReady='true';
    const video=frame.querySelector('video');if(!video)return;prepareVideo(video);
    const sync=()=>{if(!document.hidden && visibleEnough(frame))startVideo(video);else stopVideo(video);};
    const observer=new IntersectionObserver(sync,{threshold:[0,.15,.5]});observer.observe(frame);
    video.addEventListener('loadedmetadata',sync);video.addEventListener('canplay',sync);
    frame.addEventListener('touchend',sync,{passive:true});
    document.addEventListener('visibilitychange',sync);window.addEventListener('pageshow',sync);
    const unload=event=>{if(!event.target.contains(frame))return;observer.disconnect();stopVideo(video);document.removeEventListener('visibilitychange',sync);window.removeEventListener('pageshow',sync);document.removeEventListener('shopify:section:unload',unload);};
    document.addEventListener('shopify:section:unload',unload);sync();
  };
  const initAnnouncement=bar=>{
    if(bar.dataset.rotatorReady)return;bar.dataset.rotatorReady='true';
    const slides=[...bar.querySelectorAll('[data-announcement-slide]')];
    if(slides.length<2)return;
    let index=0,timer,hovered=false;
    const show=next=>{index=next;slides.forEach((slide,i)=>{slide.classList.toggle('is-current',i===index);slide.setAttribute('aria-hidden',i===index?'false':'true');});};
    const stop=()=>{clearInterval(timer);timer=null;};
    const start=()=>{stop();if(!hovered&&!document.hidden&&!bar.contains(document.activeElement))timer=setInterval(()=>{if(!bar.isConnected){stop();return;}show((index+1)%slides.length);},3500);};
    bar.addEventListener('mouseenter',()=>{hovered=true;stop();});
    bar.addEventListener('mouseleave',()=>{hovered=false;start();});
    bar.addEventListener('focusin',stop);bar.addEventListener('focusout',()=>requestAnimationFrame(start));
    document.addEventListener('visibilitychange',start);
    const unload=event=>{if(!event.target.contains(bar))return;stop();document.removeEventListener('visibilitychange',start);document.removeEventListener('shopify:section:unload',unload);};
    document.addEventListener('shopify:section:unload',unload);show(0);start();
  };
  const initGallery = gallery => {
    if (gallery.dataset.ready) return;
    gallery.dataset.ready = 'true';
    const track = gallery.querySelector('[data-gallery-track]');
    const links = [...gallery.querySelectorAll('[data-slide]')];
    const slides = [...track.querySelectorAll('.gallery-slide')];
    const motion = matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth';
    const go = index => track.scrollTo({left:Math.max(0, Math.min(slides.length-1,index))*track.clientWidth,behavior:motion});
    links.forEach(link=>link.addEventListener('click',event=>{event.preventDefault();go(Number(link.dataset.slide));}));
    track.addEventListener('keydown',event=>{
      if (event.target !== track) return;
      if (!['ArrowRight','ArrowLeft','Home','End'].includes(event.key)) return;
      event.preventDefault(); const index = Math.round(track.scrollLeft/track.clientWidth);
      go(event.key==='Home'?0:event.key==='End'?slides.length-1:index+(event.key==='ArrowRight'?1:-1));
    });
    const zoom=gallery.querySelector('.media-zoom');
    gallery.querySelectorAll('[data-zoom-src]').forEach(trigger=>trigger.addEventListener('click',()=>{if(!zoom?.showModal)return;const image=zoom.querySelector('[data-zoom-image]');image.src=trigger.dataset.zoomSrc;image.alt=trigger.querySelector('img')?.alt || '';zoom.showModal();}));
    zoom?.querySelector('[data-close-zoom]')?.addEventListener('click',()=>zoom.close());
    zoom?.addEventListener('click',event=>{if(event.target===zoom)zoom.close();});
    const videos=[...track.querySelectorAll('video')];
    let activeIndex=Math.round(track.scrollLeft/track.clientWidth);
    const syncVideos=()=>{
      activeIndex=Math.round(track.scrollLeft/track.clientWidth);
      const visible=!document.hidden && visibleEnough(track);
      videos.forEach(video=>{if(visible && slides[activeIndex]?.contains(video))startVideo(video);else stopVideo(video);});
    };
    videos.forEach(video=>{prepareVideo(video);video.addEventListener('loadedmetadata',syncVideos);video.addEventListener('canplay',syncVideos);});
    const videoObserver=new IntersectionObserver(syncVideos,{threshold:[0,.15,.5]});videoObserver.observe(track);
    track.addEventListener('touchend',syncVideos,{passive:true});
    track.addEventListener('scrollend',syncVideos,{passive:true});
    document.addEventListener('visibilitychange',syncVideos);window.addEventListener('pageshow',syncVideos);
    const unload=event=>{if(!event.target.contains(gallery))return;videoObserver.disconnect();videos.forEach(stopVideo);document.removeEventListener('visibilitychange',syncVideos);window.removeEventListener('pageshow',syncVideos);document.removeEventListener('shopify:section:unload',unload);};
    document.addEventListener('shopify:section:unload',unload);
    syncVideos();
    let frame;
    track.addEventListener('scroll',()=>{
      cancelAnimationFrame(frame);
      frame=requestAnimationFrame(()=>{
        const index=Math.round(track.scrollLeft/track.clientWidth);
        links.forEach((link,i)=>{if(i===index)link.setAttribute('aria-current','true');else link.removeAttribute('aria-current');});
        const counter=gallery.querySelector('[data-gallery-index]');if(counter)counter.textContent=String(index+1).padStart(2,'0');
        syncVideos();
      });
    },{passive:true});
  };
  const initProduct = section => {
    if (section.dataset.ready) return;
    section.dataset.ready='true';
    const form=section.querySelector('.product-form');
    if (!form) return;
    const button=form.querySelector('[data-add-button]');
    const message=form.querySelector('[data-product-message]');
    const bar=section.querySelector('[data-mobile-purchase]');
    const sticky=bar?.querySelector('[data-sticky-add]');
    const syncSticky=()=>{if(!sticky)return;sticky.disabled=button.disabled;sticky.textContent=button.textContent;sticky.setAttribute('aria-busy',button.getAttribute('aria-busy') || 'false');bar.querySelector('[data-sticky-price]').textContent=section.querySelector('[data-price]').textContent;};
    if(bar){const visible=()=>{bar.hidden=button.getBoundingClientRect().bottom>=0;};new IntersectionObserver(visible).observe(button);new MutationObserver(syncSticky).observe(form,{subtree:true,childList:true,characterData:true,attributes:true,attributeFilter:['disabled','aria-busy']});section.querySelector('[data-variant-select]')?.addEventListener('change',syncSticky);syncSticky();visible();}
    let pending=false;
    form.addEventListener('submit',async event=>{
      event.preventDefault();
      if (pending || button.disabled || cartBusy) return;
      pending=true;button.disabled=true;button.setAttribute('aria-busy','true');button.textContent=words().loading;message.textContent='';
      try {
        const payload=new FormData(form);payload.set('sections','cart-drawer');payload.set('sections_url',location.pathname);
        const response=await fetch(endpoint('cart/add.js'),{method:'POST',headers:{Accept:'application/json'},body:payload});
        const data=await response.json();
        if (!response.ok) throw new Error(data.description || data.message || words().error);
        announce(words().added);
        showCart(event.submitter || button);
        try {if(data.sections?.['cart-drawer'])replaceCart(data.sections['cart-drawer']);else await refreshCart();cartError('');} catch(error){cartError(words().added+' '+words().error);}
      } catch(error){message.textContent=error.message || words().error;if(event.submitter?.matches('[data-sticky-add]')){message.tabIndex=-1;message.scrollIntoView({block:'center'});message.focus({preventScroll:true});}}
      finally {pending=false;button.removeAttribute('aria-busy');const option=form.querySelector('[data-variant-select]')?.selectedOptions[0];button.disabled=option?option.dataset.available!=='true':false;button.textContent=button.disabled?button.dataset.soldText:button.dataset.addText;}
    });
    form.querySelector('[data-variant-select]')?.addEventListener('change',event=>{
      const option=event.target.selectedOptions[0];
      section.querySelector('[data-price]').textContent=option.dataset.price;
      const deliveryBadge=section.querySelector('[data-product-free-shipping]');
      if(deliveryBadge){const eligible=deliveryBadge.dataset.currency==='PLN' && Number(option.dataset.priceAmount)>=Number(deliveryBadge.dataset.threshold);deliveryBadge.hidden=!eligible;const taxNote=section.querySelector('[data-tax-note]');if(taxNote)taxNote.hidden=eligible;}
      button.disabled=option.dataset.available!=='true';button.textContent=button.disabled?button.dataset.soldText:button.dataset.addText;
      const stock=section.querySelector('[data-availability]');stock.textContent=button.disabled?stock.dataset.soldText:stock.dataset.availableText;
      const quantity=form.querySelector('[name="quantity"]');quantity.min=option.dataset.min || '1';quantity.step=option.dataset.step || '1';quantity.value=quantity.min;
      if(option.dataset.max)quantity.max=option.dataset.max;else quantity.removeAttribute('max');
      const slide=[...section.querySelectorAll('[data-media-id]')].find(node=>node.dataset.mediaId===option.dataset.media);
      if(slide){const track=slide.parentElement;track.scrollTo({left:slide.offsetLeft-track.firstElementChild.offsetLeft,behavior:'instant'});}
      const url=new URL(location.href);url.searchParams.set('variant',option.value);history.replaceState({},'',url);message.textContent='';
    });
  };
  const initRecommendations = section => {
    if (section.dataset.ready) return;section.dataset.ready='true';
    if(section.querySelector('[data-recommendation-items]')?.children.length)return;
    const observer=new IntersectionObserver(async entries=>{
      if(!entries[0].isIntersecting)return;observer.disconnect();
      try{const response=await fetch(section.dataset.url);if(!response.ok)return;const html=parse(await response.text());const items=html.querySelector('[data-recommendation-items]');if(items?.children.length)section.querySelector('[data-recommendation-items]').replaceWith(items);}
      catch{}
    },{rootMargin:'400px'});observer.observe(section);
  };
  const init = scope => {
    initShipping(scope);
    scope.querySelectorAll('[data-announcement-rotator]').forEach(initAnnouncement);
    scope.querySelectorAll('.portrait-video-frame').forEach(initPortraitVideo);
    scope.querySelectorAll('[data-gallery]').forEach(initGallery);
    scope.querySelectorAll('[data-product-section]').forEach(initProduct);
    scope.querySelectorAll('[data-recommendations]').forEach(initRecommendations);
  };
  init(document);
  document.addEventListener('shopify:section:load',event=>init(event.target));
})();
